import {
    apiRequest,
    indeksProfessionalitasCheckYear,
    indeksProfessionalitasExportExcel,
    indeksProfessionalitasDownloadLetter,
    indeksProfessionalitasCreatePeriode,
    masterWorkUnit
} from "../../../../../services/adapters/kepegawaian/indeksProfessionalitas"

class IndexRepository {

    fetchCheckYear = async (query, cancelToken) => {
        return await apiRequest("get", indeksProfessionalitasCheckYear, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchExportExcel = async (query, cancelToken) => {
        return await apiRequest("get", indeksProfessionalitasExportExcel, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDownloadLetter = async (query, cancelToken) => {
        return await apiRequest("get", indeksProfessionalitasDownloadLetter, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchCreatePeriode = async (query) => {
        return await apiRequest("post", indeksProfessionalitasCreatePeriode, {
            body: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }
}

export default IndexRepository